import React from 'react';
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';
import styles from '../scss/appliedJobs.module.scss';
import { isJobActive, setClassForStatusBubble } from '../../../../utils/helpers';

export const appliedJobsConstant = (t) => {
  return [
    {
      title: t('dashboard.jobs.appliedlist.id'),
      render: (rowData) => {
        return (
          <Link
            to={`/dashboard/jobs/${rowData?.Job?.Id}${window.location.search}`}
            style={isJobActive(rowData) ? null : { pointerEvents: 'none' }}
          >
            {rowData?.Job?.Id}
          </Link>
        );
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.title'),
      render: (rowData) => {
        return rowData?.Job?.JobTitle;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.type'),
      render: (rowData) => {
        return rowData?.Job?.JobType;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.industry'),
      render: (rowData) => {
        return rowData?.Job?.Industry;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.status'),
      dataClass: `${styles.statusColumn} text-nowrap`,
      render: (rowData) => {
        return (
          <div className={`${styles.tags} ${setClassForStatusBubble(rowData?.JobApplicationStatus?.UIName, styles)}`}>
            {rowData?.JobApplicationStatus?.UIName}
          </div>
        );
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.dateapplied'),
      headerClass: 'text-nowrap',
      render: (rowData) => {
        return dateFormat(rowData?.CreatedDate, 'dd mmm yyyy');
      }
    }
  ];
};
